import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import PageWrapper from '../PageWrapper';
import { getPartnersSectionData } from '../../../services/homepage';
import SEO from '../../common/SEO';
import AlliancesSection from '../Homepage/seccions/AlliancesSection';

const AliancesPage = () => {
    const integrations = [
        { title: 'Contenido y distribución', icon: '/assets/nosotros/integracion-fuentes.png', desc: 'Acceso directo a los principales inventarios del mundo: aéreos (NDC/GDS), hoteles, asistencias y más.' },
        { title: 'Integraciones técnicas (APIs)', icon: '/assets/nosotros/integracion-tecnologia.png', desc: 'Conectividad ágil y segura mediante estándares modernos de la industria tecnológica.' },
        { title: 'Operación y Pagos', icon: '/assets/nosotros/integracion-pagos.png', desc: 'Integración con pasarelas de pago y sistemas de backoffice para una operación fluida.' },
    ];

    return (
        <PageWrapper
            fetchData={getPartnersSectionData}
            render={(data) => {
                if (!data) return null;

                return (
                    <Box className="alianzas-page">
                        <SEO 
                            title="Alianzas | Partners e integraciones en travel tech — E2E Travel Solutions"
                            description="Trabajamos con partners e integraciones para potenciar contenido, distribución y operación. Conectamos tecnología y negocio para escalar tu compañía."
                        />
                        
                        <Box sx={{ py: { xs: 8, md: 10 }, bgcolor: '#eff2f9', textAlign: 'center' }}>
                            <Container maxWidth="lg">
                                <Typography variant="h1" sx={{ mb: 3, fontWeight: 800, color: '#4e429c', fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
                                    Partners e integraciones que suman valor real
                                </Typography>
                                <Typography variant="h6" sx={{ color: '#666', maxWidth: '800px', mx: 'auto', lineHeight: 1.6 }}>
                                    Construimos un ecosistema robusto de colaboraciones para ofrecer las mejores soluciones tecnológicas del mercado.
                                </Typography>
                            </Container>
                        </Box>

                        <AlliancesSection data={data} />

                        <Container maxWidth="lg" sx={{ py: 10 }}>
                            <Typography variant="h3" align="center" sx={{ mb: 6, fontWeight: 800, color: '#4e429c' }}>
                                Cómo potenciamos tu negocio
                            </Typography>
                            <Grid container spacing={4}>
                                {integrations.map((item, idx) => (
                                    <Grid item xs={12} md={4} key={idx}>
                                        <Paper sx={{ 
                                            p: 4, 
                                            height: '100%', 
                                            borderRadius: '24px', 
                                            boxShadow: '0 15px 45px rgba(0,0,0,0.05)',
                                            textAlign: 'center',
                                            border: '1px solid #f0f0f0',
                                            transition: 'transform 0.3s ease',
                                            '&:hover': { transform: 'translateY(-10px)' }
                                        }}>
                                            <Box component="img" src={item.icon} sx={{ width: 80, height: 80, mb: 3, objectFit: 'contain' }} />
                                            <Typography variant="h5" sx={{ mb: 2, fontWeight: 800, color: '#4e429c' }}>
                                                {item.title}
                                            </Typography>
                                            <Typography variant="body1" sx={{ color: '#666', lineHeight: 1.7 }}>
                                                {item.desc}
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                        </Container>
                    </Box>
                );
            }}
        />
    );
};

export default AliancesPage;
